// third party imports
import PropTypes from 'prop-types';

// material-ui
import TextField from '@mui/material/TextField';

const InputText = (props) => {
    const { id = '', name = '', value = '', onChange = () => {}, type = 'text' } = props || {};
    return (
        <TextField
            fullWidth
            id={id}
            value={value}
            label={name}
            onChange={onChange}
            type={type}
            {...props}
            onWheel={(e) => e.target.blur()}
        />
    );
};

export default InputText;

InputText.propTypes = {
    props: PropTypes.object
};
